import humps from "humps"
import qs from "qs"

interface BuildQueryStringOptions {
  includeKeys?: string[]
}

const alphabeticalSort = (a: string, b: string) => {
  return a.localeCompare(b)
}

const _flattenObject = (
  object: object
): Record<string, unknown> =>
  Object.assign(
    {},
    ...Object.entries(object).flatMap(([key, value]) =>
      typeof value === "object" &&
      value !== null &&
      !Array.isArray(value)
        ? _flattenObject(value)
        : { [key]: value }
    )
  )

export const buildQueryString = (
  queryObject: object,
  { includeKeys }: BuildQueryStringOptions = {}
) => {
  if (!queryObject) return ""
  const searchParams = qs.stringify(
    humps.decamelizeKeys<Record<string, unknown>>(
      _flattenObject(queryObject)
    ),
    {
      arrayFormat: "brackets",
      addQueryPrefix: true,
      sort: alphabeticalSort,
      ...(includeKeys && { filter: includeKeys }),
    }
  )

  return searchParams || ""
}
